module.exports = __webpack_public_path__ + "img/chuvak-extended.d2f4ca54.png";